export const UPDATE_AVAILABILITY_SETTINGS_ERROR = 'Error saving availability settings.';
export const AVAILABILITY_CUSTOM_VALIDATION_ERROR_MESSAGE =
    'Extended Availability must be greater than General Availability.';
